import React, { createContext, useContext, useState } from 'react'

const ctx = createContext({ canProceed: false, setCanProceed: () => {} })

export const BookingBarProvider = ({ children }) => {
  const [canProceed, setCanProceed] = useState(false)
  return <ctx.Provider value={{ canProceed, setCanProceed }}>{children}</ctx.Provider>
}

export const useBookingBar = () => useContext(ctx)
